import {
  enhanceWrapped,
  InputBase,
} from '../../../../../configure/components/InputBase';

const INPUT_LABEL = 'Subscription message';
const INPUT_PLACEHOLDER = 'Do you want to unsubscribe?';
const FIELD_TO_UPDATE = 'unsubscribeMessage';

const enhance = enhanceWrapped(FIELD_TO_UPDATE, INPUT_LABEL, INPUT_PLACEHOLDER);
const UnsubscribeText = enhance(InputBase);

export default UnsubscribeText;
